import { ValidationResult, RequiredFieldCheck } from '@/views/helpers/validation-result';

export default {
  validate (recovery) {
    let validationResult = new ValidationResult();
    return validationResult;
  },

  requiredFields (recovery) {
    let validationResult = new ValidationResult();
    validationResult.push(RequiredFieldCheck('recoveryDate', recovery.recoveryDate));
    return validationResult;
  }
};
